/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseWidget from 'scripts/base-widget';
import can from 'can';
import Model from 'can/model/model';
import PlayerService from 'scripts/services/player-service';
import appContext from 'scripts/app-context';
import 'components/player/shots-and-stats/shots-and-stats';

const PlayerShotsAndStatsModel = Model.extend(
    {},
    {
        define: {
            fetching: {
                type: 'boolean',
                value: true,
            },
            player: {
                Type: can.Map,
                value: null,
            },
            playerInfo: {
                Type: can.Map,
                value: null,
            },
        },
    },
);

export const ShotsAndStats = BaseWidget.extend({
    init() {
        const player = this.options.player || null;
        this.viewModel = new PlayerShotsAndStatsModel({
            player: player,
            playerInfo: null,
            initialLoad: true,
        });
        this.view = can.stache(
            '<player-stots-and-stats {player}="player" {player-info}="playerInfo" {initial-load}="initialLoad" />',
        );
        this._super();
        this.fetchData(player);
    },

    fetchData(player) {
        PlayerService.getPlayerInfo(
            player.identifier,
            (ev, data) => {
                this.viewModel.attr('playerInfo', data);
                this.viewModel.attr('initialLoad', false);
                appContext.model.attr(
                    'shotsAndStatsIsAvailable',
                    !!this.viewModel.attr('playerInfo.roundsInfo'),
                );
            },
            (ev, value) => this.viewModel.attr('fetching', value),
            (error) => {
                appContext.model.attr('shotsAndStatsIsAvailable', false);
            },
        );
    },
});
